import mixpanel from 'mixpanel-browser';
import { useCallback } from 'react';

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || '';

export const initMixpanel = () => {
  if (IS_PRODUCTION && typeof window !== 'undefined') {
    mixpanel.init('ccf189e9fbff64c71dc700ea3a3558ff', {
      //debug: process.env.NODE_ENV === 'development',
      debug: false,
      track_pageview: true,
      persistence: 'localStorage',
      // Session replay (rrweb) serializes DOM mutations on the main thread for every
      // recorded visitor — a major INP/TBT cost. Sample a small fraction instead of 100%.
      record_sessions_percent: 10,
      record_idle_timeout_ms: 300000,
      record_heatmap_data: false,
      record_mask_text_selector: '', //Default is *, this unblocks text
    });
  }
};

export const trackEvent = (event: string, props?: Record<string, any>) => {
  if (IS_PRODUCTION && typeof window !== 'undefined') {
    mixpanel.track(event, props);
  }
};

export const identifyUser = (userId: string) => {
  if (typeof window !== 'undefined') {
    mixpanel.identify(userId);
  }
};

export const useMixpanelEvent = () => {
  return useCallback((eventName: string, props?: Record<string, any>) => {
    trackEvent(eventName, props);
  }, []);
};

export const MIXPANEL_EVENTS = {
  HOME_PAGE_VIEWED: 'HOME_PAGE_VIEWED',
  HOME_PAGE_SEARCH: 'HOME_PAGE_SEARCH',
  PLAN_LISTING_RESPONSE: 'PLAN_LISTING_RESPONSE',
  PLAN_LISTING_LOADED: 'PLAN_LISTING_LOADED',
  PLAN_LISTING_UPDATE: 'PLAN_LISTING_UPDATE',
  PLAN_DETAILS_LOADED: 'PLAN_DETAILS_LOADED',
  PLAN_DETAILS_RESPONSE: 'PLAN_DETAILS_RESPONSE',
  PLAN_DETAILS_PLAN_OPTION_CHANGED: 'PLAN_DETAILS_PLAN_OPTION_CHANGED',
  PLAN_DETAILS_PAYMENT_OPTION_CHANGED: 'PLAN_DETAILS_PAYMENT_OPTION_CHANGED',
  PLAN_DETAILS_BUY_NOW: 'PLAN_DETAILS_BUY_NOW',
  PLAN_DETAILS_ERROR: 'PLAN_DETAILS_ERROR',
  CHECKOUT_LOADED: 'CHECKOUT_LOADED',
  CHECKOUT_PLANS_DETAILS_RESPONSE: 'CHECKOUT_PLANS_DETAILS_RESPONSE',
  CHECKOUT_PAYMENT_OPTION_CHANGED: 'CHECKOUT_PAYMENT_OPTION_CHANGED',
  CHECKOUT_VIN_VERIFY_ATTEMPT: 'CHECKOUT_VIN_VERIFY_ATTEMPT',
  CHECKOUT_VIN_VERIFY_SUCCESS: 'CHECKOUT_VIN_VERIFY_SUCCESS',
  CHECKOUT_VIN_VERIFY_FAILED: 'CHECKOUT_VIN_VERIFY_FAILED',
  CHECKOUT_ERROR: 'CHECKOUT_ERROR',
  CHECKOUT_ATTEMPT: 'CHECKOUT_ATTEMPT',
  CHECKOUT_SUCCESS: 'CHECKOUT_SUCCESS',
  CHECKOUT_FAILED: 'CHECKOUT_FAILED',
  COLLECTED_LEAD_INFO: 'COLLECTED_LEAD_INFO',
} as const;

export type MixPanelEvents = ObjectValues<typeof MIXPANEL_EVENTS>;
